import { Component, OnInit } from '@angular/core';
import { AppTemplateComponent } from '../template/app.template.component';
import { AuthService } from '@app/shared/services/auth.service';
import { FiscalizationService } from '@app/shared/services/fiscalization.service';

@Component({
  selector: 'app-topbar',
  templateUrl: './app.topbar.component.html'
})
export class AppTopBarComponent implements OnInit {

  nome: string;
  cpf: string;
  isAuthenticated = false;

  constructor(
    public template: AppTemplateComponent,
    public authService: AuthService
  ) {}

  ngOnInit() {
    this.iniciarDadosUsuario();
  }

  private async iniciarDadosUsuario() {
    if (await this.authService.isAuthenticated()) {
      const { given_name, preferred_username } = this.authService.getTokenPayload();
      this.isAuthenticated = true;
      this.nome = given_name;
      this.cpf = preferred_username;
    }
  }

  logout() {
    this.authService.signOut();
  }
}
